module.exports = __webpack_public_path__ + "static/img/Appointment_Listing_and_Encounter_Status.ebcfed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Appointment_Listing_and_Encounter_Status.jpg
// module id = 3w0a
// module chunks = 7